var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8481,
    cy: 17.8481,
    r: 17.8481,
    fill: "url(#paint0_linear_337_342)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 19.875H21.525C22.8084 18.8417 23.625 17.2667 23.625 15.5C23.625 12.4 21.1 9.875 18 9.875C14.9 9.875 12.375 12.4 12.375 15.5C12.375 17.5917 13.525 19.425 15.2333 20.3917C15.0083 20.6416 14.875 20.975 14.875 21.3333V22.1667C14.875 22.2416 14.8833 22.3083 14.9 22.375H13.8333C13.0333 22.375 12.375 23.0333 12.375 23.8333V24.6667C12.375 25.4666 13.0333 26.125 13.8333 26.125H22.1667C22.9667 26.125 23.625 25.4666 23.625 24.6667V23.8333C23.625 23.7583 23.6167 23.6916 23.6 23.625H24.6667C25.4667 23.625 26.125 22.9666 26.125 22.1667V21.3333C26.125 20.5333 25.4667 19.875 24.6667 19.875ZM13.625 15.5C13.625 13.0833 15.5917 11.125 18 11.125C20.4083 11.125 22.375 13.0833 22.375 15.5C22.375 17.9166 20.4083 19.875 18 19.875C15.5917 19.875 13.625 17.9166 13.625 15.5ZM22.375 24.6667C22.375 24.7833 22.2833 24.875 22.1667 24.875H13.8333C13.7167 24.875 13.625 24.7833 13.625 24.6667V23.8333C13.625 23.7167 13.7167 23.625 13.8333 23.625H22.1667C22.2833 23.625 22.375 23.7167 22.375 23.8333V24.6667ZM24.875 22.1667C24.875 22.2833 24.7833 22.375 24.6667 22.375H16.3333C16.2167 22.375 16.125 22.2833 16.125 22.1667V21.3333C16.125 21.2167 16.2167 21.125 16.3333 21.125H24.6667C24.7833 21.125 24.875 21.2167 24.875 21.3333V22.1667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5407 15.9971L19.095 18H18.198L16.5341 15.8431V15.5178H17.1641C17.7803 15.5178 18.2083 15.2542 18.2733 14.8331H16.5375V14.3058H18.2699C18.2083 13.8881 17.8625 13.6348 17.3524 13.6348H16.5375V13.0596H20.0092V13.5903H18.5917V13.6416C18.804 13.7854 18.9581 14.0353 18.9889 14.3058H20.0092V14.8331H18.9957C18.9102 15.4802 18.3144 15.98 17.5989 15.9971H17.5407Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_337_342",
    x1: 18.6096,
    y1: 0,
    x2: 18.6096,
    y2: 31.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998403,
    stopColor: "#F94327"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.d443f55a158e76d9df7c9b2648dd0ee7.svg";
export { ForwardRef as ReactComponent };